export default __webpack_public_path__ + "static/media/readly.bf46056d.png";